import React, { useEffect, useRef, useState } from "react";
import trash from "../../../../assets/center/images/trash.svg";
import * as DoctorService from "../../../admin/services/doctor.services";
import { ACTIVE, DEACTIVE, DOCTOR_SPECIALIZATION, GENDER, LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, ROLE, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../validator/validation";
import { useTranslation } from "react-i18next";
import {
    capitalizeFirstLetter,
    formatDateFromTime,
    formatePickerDate,
    getColorType,
    getDateWithTime,
    getDayDiff,
    globalLoader,
    handleOffcanvasScroll,
    handleServerValidations,
    TrimText,
    useDebouncing,
} from "../../../../utils/commonfunction";
import { CATEGORIES_TAX_TYPES } from "../../../../utils/Constants";
import { ReactSortable } from "react-sortablejs";
import CustomError from "../../../../utils/customError";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import GridLoader from "../../shared/gridLoader";
import RecordNotFound from "../../shared/recordNotFound";
import PhoneInput from "../../../../utils/PhoneInput";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import DefaultProfileImg from "../../../../assets/center/images/default_user_profile.png";

export default function Doctor() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { doctorValidationSchema, editDoctorValidationSchema } = useValidationSchemas();
    const addCategoryCloseBtn = useRef();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [staffDetail, setStaffDetail] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [attendance, setAttendance] = useState([]);
    const [attendanceLoader, setAttendanceLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [employeeId, setEmployeeId] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const fileSelectInput = useRef();
    const [attendancePage, setAttendancePage] = useState(1);
    const [attendanceOffset, setAttendanceOffset] = useState(0);
    const [attendanceTotalRecords, setAttendanceTotalRecords] = useState(0);
    const toggleEyeIcon = () => {
        showPassword ? setShowPassword(false) : setShowPassword(true);
    };

    // State for search input and select dropdown
    const [searchValue, setSearchValue] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [sortConfig, setSortConfig] = useState({ column: "createdAt", order: SORT_D });
    const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: "date", order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const prepareGlobalSearch = (value) => {
        setPrevGlobalSearch(globalSearch);
        setGlobalSearch(value);
    };
    const searchDebounce = useDebouncing(prepareGlobalSearch);

    const handleFilterStatusChange = (e) => {
        if (e.target.value) {
            prepareSearch("status", Number(e.target.value));
        } else {
            prepareSearch("status", "");
        }
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchDebounce(value);
    };

    // Handle select dropdown change
    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        handleFilterStatusChange(e);
    };

    const handleSort = (key) => {
        let direction = SORT_A;
        if (sortConfig.column === key && sortConfig.order === SORT_A) {
            direction = SORT_D;
        }
        setSortConfig({ column: key, order: direction });
    };

    useEffect(() => {
        // if (!location.pathname.includes("staff-attendance")) {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        // Determine the page number
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1; // Reset to the first page if globalSearch changes
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        DoctorService.List(formData, ROLE.CENTER)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/center/settings/doctor/${data.data.page}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);

    const getStaffDetail = (item) => {
        DoctorService.Details(item._id, ROLE.CENTER)
            .then((response) => {
                editForm.setValues({
                    o_id: response?.data?._id || "",
                    first_name: response?.data?.first_name || "",
                    last_name: response?.data?.last_name || "",
                    email: response?.data?.email || "",
                    phone_number: response?.data?.phone_number || "",
                    dob: response?.data?.dob || "",
                    gender: response?.data?.gender || "",
                    profile_image: response?.data?.profile_image || "",
                    specialization: response?.data?.specialisation || "",
                    startTime: response?.data?.center?.start_available_time || "",
                    endTime: response?.data?.center?.end_available_time || "",
                });
                setStaffDetail(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleFileSelection = (event, form) => {
        if (event.target.files.length) {
            form.setFieldValue("profile_image", event.target.files[0]);
        }
    };

    const handleFilePreview = (file) => {
        if (typeof file === "string") {
            return file;
        } else {
            return URL.createObjectURL(file);
        }
    };

    const addForm = useFormik({
        initialValues: {
            profile_image: "",
            first_name: "",
            last_name: "",
            email: "",
            dob: "",
            gender: "",
            specialization: "",
            phone_number: "",
            startTime: "",
            endTime: "",
        },
        validationSchema: doctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            formData.append("email", values.email);
            formData.append("phone_number", values.phone_number);
            formData.append("dob", values.dob);
            formData.append("gender", values.gender);
            formData.append("specialisation", values.specialization);
            formData.append("start_available_time", values.startTime);
            formData.append("end_available_time", values.endTime);
            if (values.profile_image) {
                formData.append("profile_image", values.profile_image);
            }
            setAddSubmissionLoader(true);
            // add(formData)
            //   .then((response) => {
            //     setAddSubmissionLoader(false);
            //     if (response.success) {
            //       Swal.fire({
            //         icon: "success",
            //         text: response.message,
            //         ...SWAL_SETTINGS,
            //       });
            //       resetForm();
            //       setOpenWithHeader(false);
            //       setRefreshList(!refreshList);
            //     } else {
            //       Swal.fire({
            //         icon: "error",
            //         text: handleServerValidations(response),
            //         ...SWAL_SETTINGS,
            //       });
            //     }
            //   })
            //   .catch((error) => {
            //     setAddSubmissionLoader(false);
            //     console.error("Error updating profile", error);
            //   });
            console.log(values);
        },
    });

    const editForm = useFormik({
        initialValues: {
            o_id: "",
            employee_id: "",
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            dob: "",
            gender: "",
            specialization: "",
            phone_number: "",
            startTime: "",
            endTime: "",
        },
        validationSchema: editDoctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditSubmissionLoader(true);
            const formData = new FormData();
            formData.append("o_id", staffDetail._id);
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            formData.append("email", values.email);
            formData.append("phone_number", values.phone_number);
            formData.append("dob", values.dob);
            formData.append("gender", values.gender);
            formData.append("specialisation", values.specialization);
            formData.append("start_available_time", values.startTime);
            formData.append("end_available_time", values.endTime);
            formData.append("profile_image", values.profile_image);
            DoctorService.Edit(formData, ROLE.CENTER)
                .then((response) => {
                    setEditSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeaderEdit(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setEditSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const getDateWithTime = (timeValue) => {
        if (!timeValue) return null;
        const [hours, minutes, seconds] = timeValue.split(":");
        const date = new Date();
        date.setHours(hours, minutes, seconds || "00");
        return date;
    };

    const handleStartTimeChange = (e) => {
        addForm.setFieldTouched("startTime", true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(":");
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || "00";
            addForm.setFieldValue("startTime", `${hours}:${minutes}:${seconds}`);
        }
    };

    const handleEndTimeChange = (e) => {
        addForm.setFieldTouched("endTime", true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(":");
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || "00";
            addForm.setFieldValue("endTime", `${hours}:${minutes}:${seconds}`);
        }
    };

    return (
        <main id="main-content">
            <div className="inner-container">
                <div className="page-header d-flex align-items-center">{/* <h4 className="heading-title-text">{t("Doctors Management")}</h4> */}</div>
                <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
                    <div className="search-box">
                        <input type="text" value={searchValue} className="form-control search-input" placeholder={t("center.staff.input_placeholder_search")} onChange={handleSearchChange} />
                    </div>
                    <div className="card-head-group d-flex align-items-center gap-2"></div>
                </div>

                <div className="dashboard-content-wraper">
                    <div className="category-list-wrap">
                        <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>{t("center.staff.s_no")}</th>
                                                <th>
                                                    {t("Doctor Name")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("name")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "name" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "name" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Email")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("email")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "email" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "email" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Gender")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("gender")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "gender" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "gender" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    Contact Number
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("phone_number")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "phone_number" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "phone_number" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th style={{ width: "150px" }}>{t("center.staff.label_action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <td colSpan={8}>
                                                    <Skeleton className="mb-2" height={50} count={5} />
                                                </td>
                                            ) : List?.length ? (
                                                List.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{offset + index + 1}</td>
                                                            <td>{capitalizeFirstLetter(TrimText(item?.name, 30))}</td>
                                                            <td>{item?.email}</td>
                                                            <td>{capitalizeFirstLetter(item?.gender)}</td>
                                                            <td>{item?.phone_number}</td>
                                                            <td className="d-flex">
                                                                <div className="dropdown ms-2">
                                                                    <button
                                                                        className="btn btn-icon dropdown-toggle"
                                                                        type="button"
                                                                        id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="ti ti-dots-vertical"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getStaffDetail(item);
                                                                                }}
                                                                                data-bs-toggle="offcanvas"
                                                                                data-bs-target="#view-staff"
                                                                            >
                                                                                <i className="ti ti-eye"></i>
                                                                                {t("center.button.btn_view")}
                                                                            </a>
                                                                        </li>
                                                                        {/* <li>
                                                                            <a
                                                                              className="dropdown-item cp"
                                                                              onClick={() => {
                                                                                getStaffDetail(item);
                                                                                setOpenWithHeaderEdit(true);
                                                                              }}
                                                                            >
                                                                              <i className="ti ti-edit"></i>
                                                                              {t("center.button.btn_edit")}
                                                                            </a>
                                                                          </li> */}
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    navigate(`/center/settings/doctor/schedule/1?doctor_id=${item?._id}`);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-calendar"></i>
                                                                                Manage Schedule
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                              <td colSpan={8}>
                                                <RecordNotFound heading="center.staff.no_staff_found" />
                                            </td>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-status-info d-flex justify-content-between align-items-center">
                                    <span>
                                        {t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}
                                    </span>
                                    <nav aria-label="Page navigation example" title={page}>
                                        {totalRecords && totalRecords > 0 ? (
                                            <CustomPagination
                                                datalength={totalRecords}
                                                itemperpage={itemPerPage}
                                                currentPage={page}
                                                custompath="page"
                                                setPage={setPage}
                                                pageRoute={[{ name: "settings", path: "/center/settings/doctor" }]}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>

            {/* add item modal  */}
            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Create Doctor")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                addForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editNewEmail", "rsuite");
                    }}
                >
                    <form onSubmit={addForm.handleSubmit}>
                        <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                            <div className="avatar avatar-xl">
                                <img alt="profile_image" src={addForm?.values?.profile_image ? handleFilePreview(addForm?.values?.profile_image) : DefaultProfileImg} />
                            </div>
                            <button
                                className="cp e_none"
                                type="button"
                                onClick={() => {
                                    fileSelectInput?.current?.click();
                                }}
                            >
                                <input ref={fileSelectInput} id="profile_image" name="profile_image" accept="image/*" type="file" onChange={(e) => handleFileSelection(e, addForm)} />
                                <i className="ti ti-upload"></i>
                            </button>
                        </div>
                        <CustomError name="profile_image" form={addForm} className="text-danger text-center my-3" />
                        <div className="mb-3">
                            <label className="form-label">
                                {t("center.staff.label_first_name")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("center.staff.placeholder_first_name")}
                                name="first_name"
                                value={addForm?.values?.first_name}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="first_name" form={addForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("center.staff.label_last_name")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("center.staff.placeholder_last_name")}
                                name="last_name"
                                value={addForm?.values?.last_name}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="last_name" form={addForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("center.staff.label_email")}
                                <span>*</span>
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder={t("center.staff.placeholder_email_address")}
                                name="email"
                                value={addForm?.values?.email}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="email" form={addForm} className="text-danger" />
                        </div>

                        {/* Phone Number */}
                        <div className="mb-3">
                            <label className="form-label">
                                Phone Number
                                <span>*</span>
                            </label>
                            <PhoneInput
                                value={addForm?.values?.phone_number}
                                name={"phone_number"}
                                onChange={(e) => {
                                    addForm.setFieldValue("phone_number", e?.phone_number);
                                }}
                                placeholder={t("center.staff.placeholder_contact_number")}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="phone_number" form={addForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Gender")}
                                <span>*</span>
                            </label>
                            <select className="form-control cp" name="gender" value={addForm?.values?.gender} onChange={addForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {GENDER.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    );
                                })}
                            </select>
                            {addForm.touched.gender && addForm.errors.gender ? <div className="text-danger">{t(addForm.errors.gender)}</div> : null}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("DOB")}
                                <span>*</span>
                            </label>
                            <DatePicker
                                oneTap={true}
                                classPrefix="restaurant"
                                placeholder={t("Enter DOB")}
                                placement="autoVertical"
                                format="dd.MM.yyyy"
                                cleanable={false}
                                editable={false}
                                name="dob"
                                onChange={(e) => {
                                    addForm.setFieldTouched("dob", true);
                                    addForm.setFieldValue("dob", e);
                                }}
                                value={new Date(addForm.values.dob)}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="dob" form={addForm} className="text-danger" />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Specialization")}
                                <span>*</span>
                            </label>
                            <select className="form-control cp" name="specialization" value={addForm?.values?.specialization} onChange={addForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {DOCTOR_SPECIALIZATION.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    );
                                })}
                            </select>
                            {addForm.touched.specialization && addForm.errors.specialization ? <div className="text-danger">{t(addForm.errors.specialization)}</div> : null}
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12"></div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="openingTime"
                                            onChange={handleStartTimeChange}
                                            value={getDateWithTime(addForm.values.startTime)}
                                            onBlur={addForm.handleBlur}
                                        />
                                        <CustomError name="startTime" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        End Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="closingTime"
                                            onChange={handleEndTimeChange}
                                            value={getDateWithTime(addForm.values.endTime)}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="endTime" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                Create
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <Drawer open={openWithHeaderEdit}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Edit Doctor")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeaderEdit(false);
                                editForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editForm.handleSubmit}>
                        <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                            <div className="avatar avatar-xl">
                                <img alt="profile_image" src={editForm?.values?.profile_image ? handleFilePreview(editForm?.values?.profile_image) : DefaultProfileImg} />
                            </div>
                            <button
                                className="cp e_none"
                                type="button"
                                onClick={() => {
                                    fileSelectInput?.current?.click();
                                }}
                            >
                                <input ref={fileSelectInput} id="profile_image" name="profile_image" accept="image/*" type="file" onChange={(e) => handleFileSelection(e, editForm)} />
                                <i className="ti ti-upload"></i>
                            </button>
                        </div>
                        <CustomError name="profile_image" form={editForm} className="text-danger text-center my-3" />
                        <div className="mb-3">
                            <label htmlFor="phone_number" className="form-label">
                                Contact Number
                                <span>*</span>
                            </label>
                            <PhoneInput
                                value={editForm?.values?.phone_number}
                                name={"phone_number"}
                                onChange={(e) => {
                                    editForm.setFieldValue("phone_number", e?.phone_number);
                                }}
                                onBlur={editForm.handleBlur}
                                placeholder={t("center.staff.placeholder_contact_number")}
                            />
                            <CustomError name="phone_number" form={editForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12"></div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="openingTime"
                                            onChange={(e) => {
                                                editForm.setFieldTouched("startTime", true);
                                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                                if (match) {
                                                    const [hours, minutes] = match[0].split(":");
                                                    editForm.setFieldValue("startTime", `${hours}:${minutes}:00`);
                                                }
                                            }}
                                            value={getDateWithTime(editForm.values.startTime)}
                                            onBlur={editForm.handleBlur}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="startTime" form={editForm} className="text-danger" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        End Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="closingTime"
                                            onChange={(e) => {
                                                editForm.setFieldTouched("endTime", true);
                                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                                if (match) {
                                                    const [hours, minutes] = match[0].split(":");
                                                    editForm.setFieldValue("endTime", `${hours}:${minutes}:00`);
                                                }
                                            }}
                                            value={getDateWithTime(editForm.values.endTime)}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="endTime" form={editForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                Update
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Doctor
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="view-staff-info">
                        <div className="row gap-4">
                            {staffDetail?.profile_image ? (
                                <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                                    <div className="avatar avatar-xl">
                                        <img alt="profile_image" src={staffDetail?.profile_image ? staffDetail?.profile_image : DefaultProfileImg} />
                                    </div>
                                </div>
                            ) : null}
                            <div className="col-md-12">
                                <h4>{t("Doctor ID")}</h4>
                                <p>{staffDetail?.doctor_register_id}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Doctor Name")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.name)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Email")}</h4>
                                <p>{staffDetail?.email}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Contact Number")}</h4>
                                <p>{staffDetail?.phone_number}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("DOB")}</h4>
                                <p>{formatePickerDate(staffDetail.dob)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Gender")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail.gender)} </p>
                            </div>
                            {/* <div className='col-md-12'>
                <h4>{t("Specialization")}</h4>
                <p>{capitalizeFirstLetter(staffDetail.specialisation)} </p>
              </div> */}
                            <div className="col-md-12">
                                <h4>{t("Start Time")}</h4>
                                <p>{staffDetail?.center?.start_available_time} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("End Time")}</h4>
                                <p>{staffDetail?.center?.end_available_time} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Consultation Charge")}</h4>
                                <p>{staffDetail?.consultation_charge} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Experience(Months)")}</h4>
                                <p>{staffDetail?.experience_months} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Experience(Years)")}</h4>
                                <p>{staffDetail?.experience_years} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Qualification1")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.qualification1)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Institute1")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.institute1)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Qualification2")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.qualification2)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Institute2")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.institute2)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Document Link")}</h4>
                                {staffDetail && staffDetail.document ? (
                                    <a href={staffDetail.document} target="_blank" rel="noopener noreferrer">
                                        {"View Document"}
                                    </a>
                                ) : (
                                    "N/A"
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
